import { writable } from 'svelte/store';
export const emptyEnterprise = {
    id: 0,
    name: "",
    logo: "",
    description_fr: "",
    description_en: "",
    url: "",
    member: 0,
};
export const storeEnterprises = writable([]);
export const storeEnterprisesError = writable("");
export const storeEnterpriseId = writable(0);
